import type { Application } from 'pixi.js';

import { OVERLAY_HEIGHT, OVERLAY_WIDTH } from '../game/config';

export function bindOverlayResize(app: Application): () => void {
  const resize = (): void => {
    const scale = Math.min(window.innerWidth / OVERLAY_WIDTH, window.innerHeight / OVERLAY_HEIGHT);
    const width = Math.floor(OVERLAY_WIDTH * scale);
    const height = Math.floor(OVERLAY_HEIGHT * scale);
    app.canvas.style.width = `${width}px`;
    app.canvas.style.height = `${height}px`;
    app.canvas.style.display = 'block';
    app.canvas.style.margin = `${Math.floor((window.innerHeight - height) / 2)}px auto 0`;
  };

  resize();
  window.addEventListener('resize', resize);
  return () => window.removeEventListener('resize', resize);
}
